import Report from './components/powerbi-report/component';

export {
  Report
}